import { useAppSelector } from '@hooks/app/redux';
import { memberApiV2 } from '@lib/api';
import { Checkbox, Form, TextField } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { CreateWorkspaceForm } from '../../CreateWorkspace.schema';
import { SectionSC } from './services-form.styled';

const ServicesForm: React.FunctionComponent = () => {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;
  const { formatMessage } = useIntl();

  const { isLoading: workspaceTagsLoading, data: workspaceTags } = useQuery(
    ['getWorkplaceTags', providerId],
    async () => {
      const { data } = await memberApiV2.getWorkspaceTags(providerId as string);
      return data.data;
    },
  );

  return (
    <SectionSC label="Služby">
      <Form.FieldArray<CreateWorkspaceForm> name="workspaceTags">
        {({ form, remove, push }) => (
          <div className="checkbox-wrapper">
            {workspaceTags?.map((ch: any, idx: number) => (
              <Checkbox
                className="services-checkbox"
                value={ch.code}
                key={idx}
                checked={form.values.workspaceTags.includes(ch.code)}
                onChange={() => {
                  const valueIdx = form.values.workspaceTags.indexOf(ch.code);
                  if (valueIdx !== -1) {
                    remove(valueIdx);
                  } else {
                    push(ch.code);
                  }
                }}
              >
                {ch.name}
              </Checkbox>
            ))}
          </div>
        )}
      </Form.FieldArray>
      <Form.Field name="info" label={'Iné doplňujúce informácie'}>
        <TextField.TextArea autoSize={{ maxRows: 10, minRows: 2 }} />
      </Form.Field>
    </SectionSC>
  );
};

export default ServicesForm;
